export type AudienceType = 'parent' | 'professional';

export type ParentInterest =
	| 'sleep'
	| 'breastfeeding'
	| 'crying_fussing'
	| 'mental_health_wellbeing'
	| 'infant_sensory_motor'
	| 'solids_food'
	| 'pregnant_preparing'
	| 'everything';

export type ProfessionalType = 'registered_health_professional' | 'other_provider';

export type SelectOption<TValue extends string = string> = {
	value: TValue;
	label: string;
	disabled?: boolean;
};

export const AUDIENCE_TYPE_OPTIONS: SelectOption<'' | AudienceType>[] = [
	{ value: '', label: 'I am a...', disabled: true },
	{ value: 'parent', label: 'Parent' },
	{ value: 'professional', label: 'Health Provider' },
];

export const PARENT_INTEREST_OPTIONS: SelectOption<'' | ParentInterest>[] = [
	{ value: '', label: "Right now I'm interested in...", disabled: true },
	{ value: 'sleep', label: 'Sleep' },
	{ value: 'breastfeeding', label: 'Breastfeeding' },
	{ value: 'crying_fussing', label: 'Crying & fussing' },
	{ value: 'mental_health_wellbeing', label: 'Mental health & wellbeing' },
	{ value: 'infant_sensory_motor', label: 'Infant sensory motor development' },
	{ value: 'solids_food', label: 'Solids & food' },
	{ value: 'pregnant_preparing', label: 'Pregnant & preparing' },
	{ value: 'everything', label: 'Everything!' },
];

export const PROFESSIONAL_TYPE_OPTIONS: SelectOption<'' | ProfessionalType>[] = [
	{ value: '', label: 'I work as a...', disabled: true },
	{ value: 'registered_health_professional', label: 'Registered health professional' },
	{ value: 'other_provider', label: 'Other type of provider' },
];

export function getOptionLabel<T extends string>(options: ReadonlyArray<SelectOption<T>>, value: T): string {
	return options.find((o) => o.value === value)?.label ?? '';
}
